import { AnketaAnswerDraggable } from './AnketaAnswerDraggable';

export default AnketaAnswerDraggable;